import { Fragment } from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";

const InternalError = () => {
  let navigate = useNavigate();
  return (
    <Fragment>
      <Result
        status="500"
        title="500"
        subTitle="Sorry, something went wrong."
        extra={
          <Button
            type="primary"
            onClick={() => {
              navigate("/");
            }}
          >
            Back Home
          </Button>
        }
      />
    </Fragment>
  );
};

export default InternalError;
